import { render, staticRenderFns } from "./VerificationSuccess.vue?vue&type=template&id=493a7cab&"
import script from "./VerificationSuccess.vue?vue&type=script&lang=js&"
export * from "./VerificationSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports